module.exports = __webpack_public_path__ + "static/media/wapusd-pusd slp.6a73e424.png";